<span class="title">{{ "publicationTemplate.kpi.title" | translate }}</span>
<div class="kpis">
  @if (metrics(); as metrics) {
    @for (metric of metricKeys(); track metric) {
      <button
        class="kpi"
        (click)="onActionKpiSelected(metric)"
        [ngClass]="{ active: activeMetric() === metric }"
      >
        <span class="name">
          {{ "publicationTemplate.kpi." + metric | translate }}
        </span>
        <span class="value">{{ metrics.totals[metric] }}</span>
      </button>
    }
  } @else {
    <div class="ph-item">
      @for (item of [1, 2, 3]; track item; let i = $index) {
        <div class="kpi-ph"></div>
      }
    </div>
  }
</div>
@if (activeMetric()) {
  <div class="chart-container">
    <canvas class="chart-canvas" #canvas></canvas>
  </div>
}
@if (metrics()?.lastUpdatedAt; as lastUpdate) {
  <span class="last-update">
    {{
      "publicationTemplate.kpi.lastUpdate"
        | translate: { date: lastUpdate | date: "medium" }
    }}
  </span>
}
